<template>
  <v-footer class="purple lighten-1">
    <v-layout row wrap align-center>
      <v-flex xs12>
        <div class="white--text ml-3">
          Copyright 2019 株式会社happiness.
        </div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {};
</script>
